import React from 'react';
import {
  Container, Dimmer, Table, Card,
  Button, Avatar, Page
} from "tabler-react";
import SearchInput from '../../../components/searchInput';

const RecordsTable = ({
  headers,
  records,
  openMainModal,
  loading,
  reload,
  searchQuery,
  onSearch
}) => {
  // useEffect(() => {
  //   var location = window.location.href
  //   if (location.includes('pending'))


  //     document.body.className = 'pendingclass';
  //   return () => { document.body.className = ''; }

  // })
  return (
    <Container>
      <Page.Header>
        <Page.Title>Cities</Page.Title>
      </Page.Header>
      <Card>
        <Dimmer active={loading} loader={loading}>
          <Card.Header>
            <Card.Options>
              <SearchInput value={searchQuery} onSubmit={onSearch} />
            </Card.Options>
          </Card.Header>
          <Table
            hasOutline
            striped
          >
            <Table.Header>
              {headers.map((head, i) => (
                <Table.ColHeader
                  key={`tableHeader-${i}`}
                >
                  {head}
                </Table.ColHeader>
              ))}
              <Table.ColHeader>Actions</Table.ColHeader>
            </Table.Header>
            <Table.Body>
              {records.map((r, i) => (
                <Table.Row key={i}>
                  {Object.keys(r).map((k, i) => {
                    if (k === 'flag') {
                      return (
                        <Table.Col>
                          <Avatar size="sm" imageURL={r['flag']} />
                        </Table.Col>
                      );
                    } else if (k === 'id') {
                      return false;
                    } else {
                      return (<Table.Col>{r[k]}</Table.Col>);
                    }
                  })}
                  <Table.Col>
                    <Button
                      outline
                      color="secondary"
                      icon=""
                      size="sm"
                      onClick={() => openMainModal('city-edit', r.id, reload)}
                    >
                      Edit
                    </Button>

                    <Button
                      outline
                      color="danger"
                      icon=""
                      className="ml-2 mr-2"
                      size="sm"
                      onClick={() => openMainModal('cities--delete', r['id'], reload)}
                    >
                      Delete
                    </Button>
                  </Table.Col>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Dimmer>
      </Card>
    </Container>
  );
}

export default RecordsTable;